
import "bootstrap/dist/css/bootstrap.css";
import { useHead } from "@vueuse/head";
// import { Head } from "@egoist/vue-head";

import { defineComponent } from "vue";
import { useStore } from "vuex";

import { onMounted, computed, reactive, toRefs, h, watch } from "vue";

import VASys from "./App/VASys.vue";
import Method from "./App/Method.vue";
import VAComponents from "./App/VAComponents.vue";
import Critics from "./App/Critics.vue";
import Response from "./App/Response.vue";
import Grand from "./App/Grand.vue";
import Appendix from "./App/Appendix.vue";

import { QuestionCircleTwoTone } from "@ant-design/icons-vue";

export default defineComponent({
    name: "App",
    components: {
        VASys,
        Method,
        VAComponents,
        Critics,
        Response,
        Grand,
        Appendix,
        QuestionCircleTwoTone,
    },
    setup() {
        const store = useStore();

        const state = reactive({
            svgStr: computed(() => store.state.svgStr),
        });

        const siteData = reactive({
            title: `In Defence of Visual Analytics Systems: Replies to Critics`,
            description: ``,
        });

        useHead({
            // Can be static or computed
            title: computed(() => siteData.title),
            meta: [
                {
                    name: `description`,
                    content: computed(() => siteData.description),
                },
            ],
        });

        return {
            ...toRefs(state),
        };
    },
    computed: {},
});
